<template lang="pug">
#requests_and_holidays.row
  .col-xs-12
    .d-flex.justify-content-between.flex-column.flex-sm-row.mb-10
      h4
        span.date Time off and holidays
      div
        a.btn.btn-outline-primary(:href="timeOffReportsLink")
          | View time off transactions
    .time-off-activites
      .d-flex.justify-content-start.align-items-center.flex-column.flex-md-row.time-off-activity(
        v-for="(request, index) in timeOffRequests"
        :key="`${request.name}-${index}`"
      )
        .pl-md-10.pr-30.pb-md-0.type.pb-10.pl-0
          strong {{ request.name }}
          | : {{ $filters.formatDuration(request.amount) }}
        .pb-md-0.pb-10.pr-20
          strong From
          |
          | {{ $filters.formatDateRange(request.start, request.stop, true) }}
      .d-flex.justify-content-start.align-items-center.flex-column.flex-md-row.time-off-activity(
        v-for="(holiday, index) in holidays"
        :key="`${holiday.name}-${index}`"
      )
        .pl-md-10.pr-30.pb-md-0.type.pb-10.pl-0
          strong {{ holiday.name }}
          | : {{ $filters.formatDuration(holiday.amount) }}
        .pb-md-0.pb-10.pr-20
          strong Date
          |
          | {{ $filters.formatDate(holiday.date) }}
        .mr-md-0.ml-auto.mr-auto
</template>

<script>
import { ReportsResource } from '../../resources';

export default {
  name: 'ActivitiesTimeOffAndHolidays',
  props: {
    timeOffRequests: {
      type: Array,
      required: true,
    },
    holidays: {
      type: Array,
      required: true,
    },
    date: {
      type: String,
      required: true,
    },
  },
  computed: {
    timeOffReportsLink() {
      return ReportsResource.reportsLink({
        reportName: 'time_off_transactions',
        date: this.date,
        dateEnd: TimeUtils.format_internal_date(moment(this.date).add(1, 'day')),
      });
    },
  },
};
</script>
